import { ConsultaSeguimentoPergunta13Model } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-13/model-consultaSeguimentoPergunta13'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta13Model {
  header: MchatRfAplicacaoQueryModel
  andaSemApoio: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta13Model
}

export const convertAplicacaoPergunta13 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta13Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_13_01)
  const andaSemApoio = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_13_02)

  if (header === undefined) return null

  return {
    header,
    andaSemApoio,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_13_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_13_ANDA_SEM_APOIO: booleanToSimNaoEnum(andaSemApoio?.stPassou),
    },
  }
}
